import { render } from "./SignUpReportSuccessModal.vue?vue&type=template&id=3b79bbff&scoped=true&ts=true"
import script from "./SignUpReportSuccessModal.vue?vue&type=script&lang=ts"
export * from "./SignUpReportSuccessModal.vue?vue&type=script&lang=ts"

import "./SignUpReportSuccessModal.vue?vue&type=style&index=0&id=3b79bbff&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b79bbff"]])

export default __exports__